import { useSuggestionContext } from "pages/suggestions/context/suggestionsContext";
import PropTypes from "prop-types";
import React from "react";
import { Summarizer } from "utils/unit-summarizer";
import ItemsSummary from "../../../../components/items-summary";
import TableList from "../../../../components/table-list";
import { builderSuggestionList } from "../../utils";
import { Columns } from "./columns";
import * as S from "./styled";

const ListSuggestion = ({ data }) => {
  const { suggestionsSelecteds, setSuggestionsSelecteds } = useSuggestionContext();

  const getOriginalSuggestion = (record) => data.find((item) => item.Id === record.Id) || record;

  const normalizedSelectedSuggestions = suggestionsSelecteds.map(getOriginalSuggestion);

  const handleCheck = (checked, record) => {
    if (record) {
      const originalRecord = getOriginalSuggestion(record);
      const isSelected = normalizedSelectedSuggestions.some(
        (item) => item.Id === originalRecord.Id
      );
      const nextSelection = isSelected
        ? normalizedSelectedSuggestions.filter((item) => item.Id !== originalRecord.Id)
        : [...normalizedSelectedSuggestions, originalRecord];

      setSuggestionsSelecteds(nextSelection);
    }

    if (checked && !record) {
      const nextSelection = [
        ...normalizedSelectedSuggestions,
        ...data.filter(
          (item) => !normalizedSelectedSuggestions.some((selected) => selected.Id === item.Id)
        ),
      ];

      setSuggestionsSelecteds(nextSelection);
    }

    if (!checked && !record) {
      setSuggestionsSelecteds([]);
    }
  };

  return (
    <>
      <S.Wrapper>
        <TableList
          scope="Suggestions"
          columns={Columns()}
          data={data.map((x) => builderSuggestionList(x))}
          onChange={handleCheck}
          selected={suggestionsSelecteds.map((x) => x.Id)}
        />
      </S.Wrapper>
      {suggestionsSelecteds.length > 0 && (
        <ItemsSummary
          totalLinesSelected={suggestionsSelecteds.length}
          totalQuantity={Summarizer.suggestions.quantities(suggestionsSelecteds)}
          totalLot={Summarizer.suggestions.lots(suggestionsSelecteds)}
        />
      )}
    </>
  );
};

ListSuggestion.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      HasSnapshot: PropTypes.bool,
      LabeledFamilYCenterId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      SuggestionTypeDescription: PropTypes.string,
      SuggestionCollectDate: PropTypes.string,
      SuggestionDeliveryDate: PropTypes.string,
      SuggestionDeliveryTime: PropTypes.string,
      StockUnitSufficiency: PropTypes.string,
      BusinessUnitPlant: PropTypes.string,
      BusinessUnitName: PropTypes.string,
      StockUnitPriority: PropTypes.number,
      StockUnitCurrentQuantity: PropTypes.number,
      MaterialUnitOfMeasure: PropTypes.string,
      MaterialNumber: PropTypes.string,
      MaterialName: PropTypes.string.isRequired,
      Quantity: PropTypes.number,
      QuantityUnitOfMeasure: PropTypes.string,
      Lot: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      LotRoudingUnit: PropTypes.string,
    })
  ).isRequired,
};

export default ListSuggestion;
